import React, {useRef, useState} from "react";
import "./CreateDevice.css";
import {TEMPLATE_IDS} from "./config";
import Button from "react-bootstrap/Button";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faCheck, faPlus, faSpinner} from "@fortawesome/free-solid-svg-icons";
import Row from "react-bootstrap/Row";
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import {Collapse} from "react-bootstrap";
import ClearDevicesComponent from "../ClearDevices";

function CreateDeviceComponent({bond, onDeviceCreated}) {
    const [isVisible, setIsVisible] = useState(false);
    const [isCreating, setIsCreating] = useState(false);
    const [totalCopies, setTotalCopies] = useState(1);
    const nameRef = useRef("New Device");
    const locationRef = useRef("Office");
    const templateIdRef = useRef("A1");
    const copiesRangeRef = useRef();

    const defaultProperties = JSON.stringify({"addr": "01000", "freq": 304000, "bps": 2500, "zero_gap": 20}, null, 2);
    const propertiesRef = useRef();

    async function createDevice() {
        if (isCreating) return;
        setIsCreating(true);

        const totalCreatedCopies = totalCopies;
        const deviceProperties = JSON.parse(propertiesRef.current.value);
        for (let i = 0; i < totalCreatedCopies; i++) {
            let deviceName = nameRef.current.value;
            if (totalCreatedCopies > 1) deviceName += " " + i.toString();
            try {
                let createResponse = await bond.post("/devices/", {
                    name: deviceName, template: templateIdRef.current.value, properties: deviceProperties, location: locationRef.current.value
                })
                try {
                    const responsePayload = await createResponse.json()
                    if (responsePayload["s"] > 299) {
                        console.error("Error creating device: ", responsePayload);
                        setIsCreating(false);
                        return;
                    }
                } catch (e) {
                    console.error("Error creating device: ", createResponse);
                    setIsCreating(false);
                    return;
                }
                if (totalCopies > 1 && totalCreatedCopies > i + 1) {
                    setTotalCopies(totalCreatedCopies - i - 1);
                    copiesRangeRef.current.value = totalCreatedCopies - i - 1;
                }
            } catch (e) {
                console.warn("Error creating device");
                console.warn(e);
            }
        }
        onDeviceCreated();
        setIsCreating(false);
        setIsVisible(false);
    }

    return (
        <Row key={"create-device"}>
            <Row>
                <Button
                    variant={"outline-success"}
                    className={"deviceManagerButton"}
                    onClick={() => {
                        setIsVisible(!isVisible);
                    }}
                >
                    <FontAwesomeIcon icon={faPlus} className={isVisible ? 'fa-rotate-by' : ''}
                                     style={isVisible ? {'--fa-rotate-angle': '45deg'} : {}}/> Create

                </Button>
                <ClearDevicesComponent bond={bond} reloadDevices={() => onDeviceCreated()}/>
            </Row>
            <Collapse in={isVisible}>
                <Row className="newDeviceForm">
                    <InputGroup className="">
                        <InputGroup.Text id="basic-addon1">Name</InputGroup.Text>
                        <Form.Control
                            placeholder="Device Name"
                            aria-label="Device Name"
                            defaultValue="Device Name"
                            ref={nameRef}
                        />
                    </InputGroup>
                    <InputGroup className="">
                        <InputGroup.Text id="basic-addon1">Location</InputGroup.Text>
                        <Form.Control
                            placeholder="Location"
                            aria-label="Location"
                            defaultValue="Office"
                            ref={locationRef}
                        />
                    </InputGroup>
                    <InputGroup className="">
                        <InputGroup.Text id="basic-addon1">Template ID</InputGroup.Text>
                        <Form.Control
                            list="templates"
                            placeholder="..."
                            aria-label="..."
                            defaultValue=""
                            ref={templateIdRef}
                        />
                        <datalist id="templates">
                            {TEMPLATE_IDS.map((t) => (<option key={t}>{t}</option>))}
                        </datalist>
                    </InputGroup>
                    <InputGroup className="mb-3">
                        <InputGroup.Text id="basic-addon1">Properties<br/>(json)</InputGroup.Text>
                        <Form.Control as="textarea" className="textAreaNewDeviceProperties" ref={propertiesRef}
                                      defaultValue={defaultProperties}/>
                    </InputGroup>
                    <InputGroup className="mb-3">
                        <InputGroup.Text>Copies: <b>{totalCopies}</b></InputGroup.Text>
                        <Form.Range defaultValue={1} max={20} min={1} disabled={isCreating} ref={copiesRangeRef}
                                    onChange={(e) => setTotalCopies(parseInt(e.target.value))}
                        />
                        <Button variant={'success'} onClick={createDevice} disabled={isCreating}
                                className={"createDeviceBtn"}>
                            {isCreating ? <><FontAwesomeIcon className={"fa-spin"}
                                                             icon={faSpinner}/> Creating...</> : <>
                                <FontAwesomeIcon icon={faCheck}/> Create</>}
                        </Button>
                    </InputGroup>
                </Row>
            </Collapse>
        </Row>
    );
}

export default CreateDeviceComponent;
